// extracted by mini-css-extract-plugin
module.exports = {"section":"k_3XQPL","inner":"k_fVvSc","wrap":"k_1UVr0"};